import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function CmtsComplaintSourcePage() {
  return <CmtsMasterDataCrudShell entityKey="complaint-source" />;
}

export default CmtsComplaintSourcePage;
